// frontend/src/utils/titleUtils.js

// Function to update page title
export const updatePageTitle = (title) => {
    document.title = title ? `${title} - LeebAI` : 'LeebAI';
    // document.title = title ? `${title}` : 'LeebAI';
};

// Function to get page title based on route
export const getPageTitle = (pathname, additionalData = {}) => {
    const path = pathname.toLowerCase();

    // Chat pages - show thread name if available
    if (path.startsWith('/chat/') && additionalData.threadName) {
        return additionalData.threadName;
    }
    if (path === '/chat') {
        return 'Chat';
    }

    // Admin pages
    if (path.startsWith('/admin')) {
        if (path.includes('/usage')) {
            return 'Usage Analytics';
        }
        if (path.includes('/organizations')) {
            return 'Organizations';
        }
        if (path.includes('/requests')) {
            return 'Individuals';
        }
        if (path.includes('/plans')) {
            return 'Plan Settings';
        }
        if (path.includes('/models')) {
            return 'Models';
        }
        return 'Admin Dashboard';
    }

    // Organization pages
    if (path.startsWith('/org')) {
        if (path.includes('/employees')) {
            return 'Employees';
        }
        if (path.includes('/plans')) {
            return 'Subscription Plans';
        }
        if (path.includes('/dashboard')) {
            return 'Organization Dashboard';
        }
        return 'Organization';
    }

    // Other pages
    if (path === '/') {
        return 'Home';
    }
    if (path === '/login') {
        return 'Login';
    }
    if (path === '/register') {
        return 'Register';
    }
    if (path === '/pricing') {
        return 'Pricing';
    }
    if (path === '/upgrade') {
        return 'Upgrade';
    }

    return 'LeebAI';
}; 